import React, {useEffect, useState} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import classes from '../Services.module.scss'
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import WhiteEmojiCard from "../../../components/white-emoji-card/WhiteEmojiCard.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Link} from "react-scroll";
import arrowIcon from '../../../media/icons/arrow-right-plain.svg'
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import Industries from "../../../components/industries/Industries.tsx";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1.05,
    slidesToScroll: 1,
};

const CrmSoftwareDev = () => {
    const { t } = useTranslation();

    const [openedBlock] = useState(null);
   
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const title = t('crmSoftwareDevelopment.title');;
    const description = t('crmSoftwareDevelopment.description', {returnObjects: true});
    const buttonText = t('crmSoftwareDevelopment.buttonText');

    const blackBlocks = t('crmSoftwareDevelopment.blackBlocks', {returnObjects: true});

    const emojiBlocks = t('crmSoftwareDevelopment.emojiBlocks', {returnObjects: true})

    const servicesBlocks = t('crmSoftwareDevelopment.servicesBlocks', {returnObjects: true})
    const dropDownBlocks = t('crmSoftwareDevelopment.processBlocks', {returnObjects: true})


    const modules = t('crmSoftwareDevelopment.weBuildModules', {returnObjects: true})

  

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
            left: t('crmSoftwareDevelopment.Faq.left', {returnObjects: true}),
            right: t('crmSoftwareDevelopment.Faq.right', {returnObjects: true}),
    };


    return (
        <>
            <Helmet>
                <title>
                    CRM Software Development Services | Custom CRM Solutions – Goteco
                </title>
                <meta
                    name="description"
                    content="Custom CRM software development: consulting, integration, automation, analytics. Improve customer engagement and sales productivity with tailored CRM solutions."
                />
                <link rel="canonical" href="https://go-te.co/services/crm-software-development-services" />
            </Helmet>
        <main>
            <Heading title={title} description={description} buttonText={buttonText} maxWidth={989}/>
            <section className={`${classes['blocks-right']} section--light-gray`}>
                <h2>{t('crmSoftwareDevelopment.blackBlocksTitle')}</h2>
                <div className={classes['blocks-container']}>
                    {blackBlocks.map(({icon, text}) => <BlackCardWithIcon key={icon} iconName={icon} text={text}/>)}
                </div>
            </section>
            <section className={`${classes['text-with-emoji-cards']} section--white`}>
                <div>
                    <h2>{t('crmSoftwareDevelopment.whatIsIt')}</h2>
                    <div>
                        <p>{t('crmSoftwareDevelopment.whatIsItText')}</p>
                        <strong>{t('crmSoftwareDevelopment.whatIsItText2')}</strong>
                    </div>
                </div>
                <div>
                    <div className={classes['blocks-container']}>
                        {emojiBlocks.map(({icon, text}) => <WhiteEmojiCard key={icon} icon={icon} text={text}/>)}
                    </div>
                </div>
            </section>


            <section className={`${classes['services-container']} section--dark-gray`}>
                <h2>{t('crmSoftwareDevelopment.ourItCons')}</h2>
                <span>{t('crmSoftwareDevelopment.ourItConsText')}</span>
                <div className={classes['blocks-container']}>
                    {servicesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                   text={text} key={title}/>)}
                </div>
                <Slider {...settings} className={classes.slider}>
                    {servicesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                   text={text} key={title}/>)}
                </Slider>
            </section>

            <section className={`${classes['modules-container']} section--white`}>
                <div>
                    <h2>{t('crmSoftwareDevelopment.weBuild')}</h2>
                    <p>{t('crmSoftwareDevelopment.weBuildText')}</p>
                </div>
                <div className={classes.blocks}>
                    {modules.map((text) => <div key={text} className={classes.module}>{text}</div>)}
                </div>
            </section>

            <section className={'section--dark-gray'}>
                <div className={classes["container"]}>
                    <div className={classes["left"]}>
                        <h2 className={classes["header"]}>{t('crmSoftwareDevelopment.process')}</h2>
                        <p className={classes["text"]}>{t('crmSoftwareDevelopment.processText')}</p>
                        <Link className={classes.button} smooth={true} to="contact">
                            <span>{buttonText}</span><img alt="" src={arrowIcon}/>
                        </Link>
                    </div>

                    <div className={classes["right"]}>
                        <div className={classes["drop-down"]}>
                            {dropDownBlocks.map((block, index) => (
                                <div
                                    key={index}
                                    id={index.toString()}
                                    className={classes["drop-down__block"]}
                                >
                                    <div
                                        className={classes["top"]}
                                    >
                                        <div className={classes["drop-down__block__title"]}>
                                            {block.title}
                                        </div>
                                    </div>

                                    <div
                                        className={`${classes["drop-down__content"]} ${
                                            openedBlock === index ? classes["visible"] : classes["hidden"]
                                        }`}
                                    >
                                        {block.content.map((text) => (
                                            <p key={text}>{text}</p>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className={`section--white ${classes.industries}`}>
                <div>
                    <h2>{t('crmSoftwareDevelopment.industriesWeServe')}</h2>
                    <p>{t('crmSoftwareDevelopment.industriesWeServeText')}</p>
                </div>
                <div>
                    <Industries/>
                </div>
            </section>

            <section className="section--light-gray" id="nav-dark">
                <FrequentlyAskedQuestions title={t('crmSoftwareDevelopment.Faq.title')} questions={questions}/>
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard 
                title={t('crmSoftwareDevelopment.formCard.title')} 
                subtitle={t('crmSoftwareDevelopment.formCard.subtitle')} 
                message={t('crmSoftwareDevelopment.formCard.message')}
                buttonText={t('crmSoftwareDevelopment.formCard.buttonText')}  
                labels={t('crmSoftwareDevelopment.formCard.labels',  {returnObjects: true})}
                top={3} 
                id='contact'/>
            </section>
        </main>
        </>
    );
};

export default CrmSoftwareDev;